// TODO: Remove ListType from elsewhere
export enum TargetedListTypesEnum {
    both,
    contact,
    outlet,
    empty
}
